import React from "react";
import { Box, Divider, Text, Group } from "@mantine/core";
import tinycolor from "tinycolor2";

import { FILTER_INPUT_COMPONENTS } from "./inputs";

import { displayEmoji } from "../../../../utils/Emoji";
import isSpaceThemed from "../../../../utils/IsSpaceThemed";
import isDark from "../../../../utils/IsDarkColor";

export default function FilterList({
  type,
  section,
  colors = {},
  data = [],
  isEditMode,
  onCreateFilter,
  onUpdateFilter,
  onRemoveFilter,
  onUpdatePropertyFilter
}) {
  if (!Array.isArray(data) || data.length === 0) return null;

  const filteredData = isEditMode ? data : data.filter((item) => !!item.value);
  const visibilityData = isEditMode ? filteredData : filteredData.filter((item) => {
    const _visibility = Array.isArray(item.visibility) ? item.visibility : ["all"];
    const onlyManagers = _visibility.includes("managers") ? ["manager", "admin"].includes(window.$currentRole) : true;
    return (_visibility.includes(type) || _visibility.includes("all")) && onlyManagers;
  });

  const dividerColor = isSpaceThemed(colors)
    ? isDark(colors.background_color)
      ? tinycolor(colors.background_color).lighten(20).toString()
      : tinycolor(colors.background_color).darken(20).toString()
    : "#e9ecef";

  const color = isSpaceThemed(colors) ? (section === "members" && type === "card") ? colors?.sidebar_text_color : colors?.default_text_color : null;

  return (
    <Box>
      {visibilityData.length > 0 && section !== "list" && type !== "creation" ? (
        (type === "card" || type === "page") && section !== "space-modal" ? (
          <Divider my={20} color={dividerColor} />
        ) : (
          <Box sx={{ height: 20 }} />
        )
      ) : visibilityData.length === 0 && type === "page" ? (
        <Box sx={{ height: 10 }} />
      ) : null}

      {visibilityData.map((item, index) => {
        const Component = FILTER_INPUT_COMPONENTS[item.format];
        const selectedFilterId = item.member_filter_id || item.space_filter_id;
        return (
          <Box key={index} mb={section === "list" || type === "creation" ? 15 : 20}>
            {section !== "list" && (
              <Group spacing={0} mb={5}>
                <Box sx={{ width: 16 }} align="center">
                  {displayEmoji(item.emojicon, color || "grey")}
                </Box>
                <Text size="sm" color={color || "dimmed"} transform="uppercase" ml={5}>{item.name}</Text>
              </Group>
            )}
            {Component ? (
              <Component
                value={item.value}
                isEditMode={isEditMode}
                options={item.options}
                color={item.color || color}
                selectedOptions={item.value}
                filterFormat={item.format}
                type={type}
                section={section}
                colors={colors}
                onChange={(new_value) => {
                  if (selectedFilterId) {
                    if (typeof onUpdateFilter === "function") {
                      onUpdateFilter(item.id, selectedFilterId, new_value);
                    }
                  } else {
                    if (typeof onCreateFilter === "function") {
                      onCreateFilter(item.id, new_value);
                    }
                  }
                }}
                onClickRemove={selectedFilterId && isEditMode ? () => {
                  if (typeof onRemoveFilter === "function") {
                    onRemoveFilter(selectedFilterId);
                  }
                } : undefined}
                onUpdateFilter={(val, cond) => {
                  if (typeof onUpdatePropertyFilter === "function") {
                    onUpdatePropertyFilter(item, val, cond);
                  }
                }}
              />
            ) : null}
          </Box>
        )
      })}

      {visibilityData.length > 0 && type === "page" && (
        <Divider
          mt={30}
          mb={20}
          color={dividerColor}
        />
      )}

    </Box>
  );
}